import { DropdownItem } from "reactstrap";
import styles from "./AppMenu.module.css";
import Status from "../Common/UI/Status/Status";
import { MisterLogo } from "@rtel/mister-icons";

function getAppIcon(name: string, active:boolean) {
  if (name == "Metrics") {
    return <MisterLogo name="MisterMetricsLogo" isActive={active} />;
  } else if (name == "Call Routing") {
    return <MisterLogo name="MisterCallRoutingLogo" isActive={active} />;
  } else if (name == "Recordings") {
    return <MisterLogo name="MisterRecordingsLogo" isActive={active} />;
  } else if (name == "Wallboards") {
    return <MisterLogo name="MisterWallboardsLogo" isActive={active} />;
  } else if (name == "Campaing Manager") {
    return <MisterLogo name="MisterCampaingManagerLogo" isActive={active} />;
  }  

}

export default function ApplicationItem(props: ApplicationProps) {

  return (
    <DropdownItem>
      <div className={styles.appbutton}>
        {getAppIcon(props.name,props.isActive)}
        <div className={ props.isActive ? styles.appmenutext : styles.appmenutextdisabled}>
          {props.name}
        </div>        
        <Status  isActive={props.isActive} color={props.isActive ? 'success' : 'disabled'} />
      </div>
    </DropdownItem>
  );
}

export interface ApplicationProps {
  name: string;
  isActive: boolean;
}
